export type ServiceUsageLegendState = "empty" | "list";

export function getServiceUsageLegendState(
  segments: ReadonlyArray<unknown>,
  totalServices: number,
): ServiceUsageLegendState {
  if (!Number.isFinite(totalServices) || totalServices <= 0) return "empty";
  return segments.length > 0 ? "list" : "empty";
}
